import './LogoUploader.css';
import { ImProfile } from 'react-icons/im';
import { useAtom } from 'jotai';
import { useLoggedUser, useShowPopUpModal, useModalInfo, useModalVersion } from '../../../data/GlobalStates';

const LogoUploader = () => {
 
      const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
      const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);
      const [ ModalVersion, setModalVersion] = useAtom(useModalVersion); 
      const [ LoggedUser, setLoggedUser ] = useAtom(useLoggedUser);

      const removeLogo = () => {
         setShowPopUpModal(true)
         setModalInfo({title: 'Usunąć Logo ?'})
         setModalVersion(18)
      };

      const addLogo = () => {
        setShowPopUpModal(true)
        setModalInfo({title: 'Dodaj Logo Firmy'})
        setModalVersion(17)
      };

  return (
    <div>
        { LoggedUser.UserLogo ?
        <div className='EditBtns' onClick={removeLogo}>
         <p>Usuń Logo</p>
         <ImProfile />
        </div>
        :
        <div className='EditBtns' onClick={addLogo}>
          <p>Dodaj Logo</p>
          <ImProfile />
        </div>
        }
    </div>
  )
}

export default LogoUploader;
